import {
  GET_NORM_FAIL,
  GET_NORM_SUCCESS,
  GET_NORMS_FAIL,
  GET_NORMS_SUCCESS,
  ADD_NORM_SUCCESS,
  ADD_NORM_FAIL,
  UPDATE_NORM_SUCCESS,
  UPDATE_NORM_FAIL,
  DELETE_NORM_SUCCESS,
  DELETE_NORM_FAIL,  
  SET_STATE_NORM
} from "./actionTypes";

const INIT_STATE = {
  norms: [],
  norm: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const norms = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NORMS_SUCCESS:
      return {
        ...state,
        norms: action.payload.norms,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_NORM:
      return { ...state, loading: action.payload }

    case GET_NORMS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_NORM_SUCCESS:
      return {
        ...state,
        norms: [...state.norms, action.payload],
      };

    case ADD_NORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_NORM_SUCCESS:
      return {
        ...state,
        norms: state.norms.map(norm =>
          norm.id.toString() === action.payload.id.toString()
            ? { ...action.payload, norm }
            : norm
        ),
      };

    case UPDATE_NORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_NORM_SUCCESS:
      return {
        ...state,
        norms: state.norms.filter(
          norm => norm.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_NORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_NORM_SUCCESS:
      return {
        ...state,
        norm: action.payload,
      };

    case GET_NORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default norms;
